module.exports = __webpack_public_path__ + "img/servier_groups.fc73518c.png";